import { Outlet } from 'react-router-dom';
import Footer from '../Posts/components/Footer/Footer';
import Header from '../Posts/components/Header/Header';
import { SiteProfileProvider } from './ProfileContext';
import styles from './Portfolio.module.css';

const SiteLayout = () => (
  <SiteProfileProvider>
    <div className={styles.siteShell}>
      <Header />
      <main className={styles.siteMain}>
        <Outlet />
      </main>
      <Footer />
    </div>
  </SiteProfileProvider>
);

export default SiteLayout;
